import { render, staticRenderFns } from "./t-input-product.vue?vue&type=template&id=b8c80268&"
import script from "./t-input-product.vue?vue&type=script&lang=js&"
export * from "./t-input-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports